// The API returns errors as `{ details }`, where details is either a message or a
// field map such as `{ login_url: ['Enter a valid URL.'] }`. Shows the first message.
interface ApiError {
  response?: { data?: { details?: unknown; detail?: unknown } };
}

export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const data = (error as ApiError)?.response?.data;
  const details = data?.details;

  if (typeof details === 'string' && details.trim()) {
    return details;
  }

  if (details && typeof details === 'object') {
    // `{ detail, code, ... }` bodies carry their message under `detail`.
    const { detail } = details as { detail?: unknown };
    const firstFieldErrors = detail ?? Object.values(details)[0];
    const message = Array.isArray(firstFieldErrors) ? firstFieldErrors[0] : firstFieldErrors;
    if (typeof message === 'string' && message.trim()) {
      return message;
    }
  }

  if (typeof data?.detail === 'string' && data.detail.trim()) {
    return data.detail;
  }

  return fallback;
};
